import { z } from "zod";

import { useAccess } from "~/access/useAccess";
import { useApiQuery, useOrgs } from "~/hooks";
import {
  getLocationFromOrgIdString,
  getOrgFromOrgIdString,
} from "~/utils/Helper";

const ENDPOINT = `/user/meq/camera/user-settings`;

export const cameraUserSettingsSchema = z.object({
  image: z
    .object({
      traits: z.string().array(),
      defaultSortingTrait: z.string(),
      defaultSortingAscending: z.boolean(),
    })
    .optional(),
  crossOrgShare: z
    .array(
      z.object({
        org: z.string(),
        location: z.string(),
        note: z.string(),
      }),
    )
    .optional(),
});

export type CameraUserSettings = z.infer<typeof cameraUserSettingsSchema>;

export default function useCameraUserSettingsQuery() {
  const org = useOrgs().currentOrg;
  const { canSee } = useAccess();
  const orgName = org && getOrgFromOrgIdString(org.idString);
  const location = org && getLocationFromOrgIdString(org.idString);

  const query = useApiQuery<CameraUserSettings>({
    config: {
      data: {
        org: orgName,
        location,
      },
      method: "post",
    },
    enabled: !!orgName && !!location && canSee("meq-camera"),
    options: { refetchOnMount: false },
    path: ENDPOINT,
    transformers: [cameraUserSettingsSchema.parseAsync],
    refetchOnWindowFocus: false,
  });

  return query;
}
